import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'quizzes',
    lazy: async () => ({ Component: (await import('./QuizzesPage')).QuizzesPage }),
  },
];
